// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"195cea61","667":"fcc21a3e"}[chunkId] + ".chunk.js";
};